<template>
    <div id="sortAndFilter">
        <div style="position: relative;">
            <div @click="$parent.$emit('sort-and-filter', 'close')" style="position: absolute;top: 0px;right: 10px; cursor: pointer; background: #fafafa; z-index: 101;"><i class="material-icons">close</i></div>
            <div class="container-fluid page" style="margin-top: 20px;">
                <div class="row">
                <div class="col">
                    <div class="meta-container"><h3 style="text-transform: uppercase; font-size: .8em; font-weight: bold; color: #d6dae2;">Sort</h3></div>
                    <select v-model="sortOrderProxy" name="sort_order" class="form-control" style="font-size: .9em;">
                        <option v-for="order in sortOrders" :value='order.value'>{{ order.label }}</option>
                    </select>
                </div>
                </div>
            </div>
            <div v-if="availableFilters" class="container-fluid page" style="margin-top: 20px;">
                <div class="row">
                <div class="col">
                    <div class="meta-container" style="height: 33px;">
                        <h3 style="text-transform: uppercase; font-size: .8em; font-weight: bold; color: #d6dae2; float: left;">Filters ({{ availableFilters.length }})</h3>
                    </div>
                    <div style="overflow-y: scroll; position: relative;">
                        <div id="filterArea">
                            <div v-if="!filter.is_hidden" v-for="filter in availableFilters">
                                <div v-if="!filter.component" class="form-group">
                                    <label :for="filter.key" style="font-size: .9em;">{{ filter.label }}</label>
                                    <select :disabled="filter.is_disabled" :value="getFilterValue(filter)" @input="(e) => { filterUpdated(filter, e.currentTarget.value) }" :name="filter.key" class="form-control" style="font-size: .9em;">
                                        <option v-if="filter.has_all_option" value="%">All</option>
                                        <option v-else disabled="disabled">Please select</option>
                                        <option v-for="(label, value) in filter.options" :value='value'>{{ label }}</option>
                                    </select>
                                </div>
                                <component 
                                    v-if="filter.component" 
                                    v-bind:is="getComponentName(filter)" 
                                    :label="filter.label"
                                    :help="filter.help_text"
                                    :config="getComponentConfiguration(filter)"
                                    :filter-options="filter.options" 
                                    :value="getFilterValue(filter)" 
                                    @input="(e) => { filterUpdated(filter, e) }"
                                ></component>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
        <div style="position: absolute; bottom: 0; width: 280px; right: 0; padding: 10px 20px; background-color: #fafafa;">
            <button class="btn btn-primary btn-sm" style="width: 100%;" @click.prevent="apply()">Apply</button>
            <a href="#" style="display: block; text-align: center; font-size: .8em; padding: .5em; color: #999;" @click.prevent="reset()">Reset sort order &amp; filters</a>
        </div>
    </div>
</template>

<script>
import ManufacturerModelSelector from './ManufacturerModelSelector'
import FilterContactPickerWrapper from './FilterContactPickerWrapper'
import FilterMultipleSelect from './FilterMultipleSelect'
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

export default {
    components: { ManufacturerModelSelector, FilterContactPickerWrapper, FilterMultipleSelect },
    props: {
        resource: {},
        defaultSortOrder: {},
        shouldLoadAll: {
            type: Boolean,
            default: false
        }
    },
    created() {
        this.$parent.$on('sort-and-filter', function(evt) {
            if ('open' === evt) {
                this.open();
            } else if('close' === evt) {
                this.close();
            }
        }.bind(this));

        window.onresize = (e) => {
            this.setFilterAreaHeight();
        }
    },
    mounted() {
        this.$el.parentNode.className += ' has-sort-and-filter';
    },
    data() {
        return { 
            previousViewState: {},
        };
    },
    computed: {
        ...mapGetters({
            filters: 'dataView/currentFiltersWithOverrides',
        }),
        ...mapState({ 
            currentViewState: state => state,
            perPage: state => state.dataView.perPage,
            availableFilters: state => state.dataView.availableFilters,
            sortOrders: state => state.dataView.availableSortOrders,
            sortOrder: state => state.dataView.currentSortOrder,
        }),
        sortOrderProxy: {
            get() {
                return this.sortOrder
            },
            set(value) {
                if (value !== undefined) {
                    this.setSortOrder(value);
                }
            }
        }
    },
    methods: {
        ...mapMutations({ 
            setSortOrder: 'dataView/setSortOrder', 
            setPage: 'dataView/setPage',
            setFilter: 'dataView/setFilter',
            setIsCustomView: 'dataView/setIsCustomView',
        }),
        ...mapActions({
            resetData: 'dataView/reset',
            load: 'dataView/get',
            loadAll: 'dataView/getAll',
            setQueryString: 'dataView/setQueryString',
        }),
        getComponentName(filter) {
            return _.isObject(filter.component) ? 
                filter.component.name : filter.component;
        },
        getComponentConfiguration(filter) {
            return _.isObject(filter.component) ? 
                filter.component.config : {};
        },
        getFilterValue(filter) {
            if (this.filters && this.filters[filter.key]) {
                return this.filters[filter.key];
            }

            return filter.default_value;
        },
        filterUpdated(filter, e) {
            Vue.set(filter, 'value', e);

            this.setFilter(filter);
        },
        apply() {
            this.setPage(1);   
            this.close(false);

            console.log(this.shouldLoadAll ? 'loadAll' : 'load')

            this[this.shouldLoadAll ? 'loadAll' : 'load']().then(response => {
                this.setIsCustomView(true);
                this.setQueryString();
                this.$emit('apply', this.shouldLoadAll ? response : response.data)
            });
        },
        reset() {
            this.resetData().then(() => {
                this.setQueryString();
            });
            
            this.close(false);
        },
        saveState() {
            this.previousViewState = JSON.parse(JSON.stringify({ 
                currentFilters: this.currentViewState.dataView.currentFilters,  
                currentPage: this.currentViewState.dataView.currentPage,
                currentSortOrder: this.currentViewState.dataView.currentSortOrder,
            }));
        },
        restoreState() {
            let state = this.currentViewState;
            state.dataView.currentFilters = this.previousViewState.currentFilters;
            state.dataView.currentPage = this.previousViewState.currentPage;
            state.dataView.currentSortOrder = this.previousViewState.currentSortOrder;
            this.$store.replaceState(state);
        },
        open(mode = null) {
            this.saveState();
            this.$el.parentNode.className += ' open';

            if (mode === 'full-height') {
                const overlay = document.createElement('div')
                overlay.style = 'z-index: 50; width: 100vw; height: 100vh; background: rgba(0,0,0,0.3); position: fixed; top: 0; left: 0;'
                overlay.setAttribute('id', 'fullHeightOverlay')
                document.body.appendChild(overlay)
                this.$el.style = "z-index: 51; top: 0;"
                this.$el.parentNode.className += ' no-fade-overlay'
            }

            this.setFilterAreaHeight();
        },
        close(reset = true) {
            if (reset) {
                this.restoreState();
            }

            this.$el.parentNode.className = this.$el.parentNode.className.replace(' open', '').replace(' no-fade-overlay','')

            setTimeout(this.closed, 250)
        },
        closed() {
            if (document.querySelector('#fullHeightOverlay')) {
                document.querySelector('#fullHeightOverlay').remove()
            }

            this.$el.style = ""
        },
        setFilterAreaHeight() {
            if (this.$el.querySelectorAll('#filterArea').length > 0) {
                this.$el.querySelectorAll('#filterArea')[0].parentNode.style.height = (
                    this.$el.offsetHeight - 300
                ) + 'px';
            }
        },
    }
}
</script>